"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForethoughtApiError = void 0;
exports.continueConversation = continueConversation;
exports.startConversation = startConversation;
exports.submitCsat = submitCsat;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// All requests go through the backend proxy (see SearchController::forethought*Action),
// which reads the per-community Solve API token from DynamoDB and forwards to
// https://app.forethought.ai/solve/api/v1. The token never reaches the browser.
var PROXY_START = '/search/forethoughtConversation';
var PROXY_CONTINUE = '/search/forethoughtConversationContinue';
var PROXY_CSAT = '/search/forethoughtCsat'; // Thrown by `timedFetch` for any non-2xx response or unparseable body. The
// `message` is always a user-safe sentence (no HTML / no status prefix);
// `status` is undefined when the failure happened before a response was
// received (e.g. network error, abort) or when the body shape was wrong.

var ForethoughtApiError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(ForethoughtApiError, _Error);

  var _super = _createSuper(ForethoughtApiError);

  function ForethoughtApiError(message, status) {
    var _this;

    (0, _classCallCheck2.default)(this, ForethoughtApiError);
    _this = _super.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", void 0);
    _this.name = 'ForethoughtApiError';
    _this.status = status;
    return _this;
  }

  return (0, _createClass2.default)(ForethoughtApiError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));

exports.ForethoughtApiError = ForethoughtApiError;

function buildHeaders() {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-CSRF-Token': (0, _csrfToken.csrfToken)()
  };
} // User-facing message for a given HTTP status. Used whenever we don't have a
// structured JSON `error`/`message`/`detail` field to pull from — keeps raw
// HTML error pages, PHP fatals, stack traces, etc. from ending up in the chat.


function genericMessageForStatus(status) {
  if (status === 401 || status === 403) {
    return 'You are not authorized to use the AI assistant right now.';
  }

  if (status === 404) {
    return 'The conversation could not be found. Please try again.';
  }

  if (status === 408 || status === 504) {
    return 'The AI assistant took too long to respond. Please try again.';
  }

  if (status === 429) {
    return 'The AI assistant is busy right now. Please try again in a moment.';
  }

  if (status === 503) {
    return 'The AI assistant is temporarily unavailable. Please try again shortly.';
  }

  if (status >= 500) {
    return 'Something went wrong on our side. Please try again.';
  }

  return 'Something went wrong with the AI assistant. Please try again.';
} // Heuristics for "this body is HTML / a server error page, not a real message".
// We treat anything served as text/html, anything that starts with a tag, or
// anything containing the kind of strings that show up in PHP-FPM / nginx /
// load-balancer error pages as untrusted and fall back to a generic message.


function looksLikeMarkupOrErrorPage(body, contentType) {
  if (contentType.includes('text/html')) return true;
  if (/^\s*<(!doctype|html|head|body|h1|pre|title)/i.test(body)) return true;
  if (/<\/?(html|head|body|h1|title|script|style)>/i.test(body)) return true;
  return false;
} // Pull a user-safe error string out of an upstream non-2xx response.
// The proxy returns `{"error": "..."}` for its own failures (403/422/503);
// Forethought itself returns `{"status", "message", "detail"}`. Anything that
// looks like an HTML page or that we can't structurally parse falls back to a
// generic, status-based message — the raw body is logged to the console
// separately (see `index.tsx` console.error calls) for debugging.


function extractErrorMessage(status, rawBody, contentType) {
  var trimmed = rawBody.trim();
  var ct = (contentType !== null && contentType !== void 0 ? contentType : '').toLowerCase();

  if (trimmed && ct.includes('application/json')) {
    try {
      var parsed = JSON.parse(trimmed);

      for (var _i = 0, _arr = ['error', 'message', 'detail']; _i < _arr.length; _i++) {
        var key = _arr[_i];
        var value = parsed[key];

        if (typeof value === 'string' && value && !looksLikeMarkupOrErrorPage(value, '')) {
          return value;
        }
      }
    } catch (_unused) {// fall through
    }
  } // HTML pages, plain-text dumps, stack traces — never print these.


  return genericMessageForStatus(status);
} // Confirm the parsed body matches the Forethought conversation contract before
// handing it to the renderer. Catches proxy mis-responses (HTML error pages,
// `{"error": "..."}` returned with a 200, empty bodies, etc.) so the UI surfaces
// a clean error instead of crashing on a missing field.


function isConversationResponse(value) {
  if (!value || (0, _typeof2.default)(value) !== 'object') return false;
  var v = value;
  return typeof v.conversation_id === 'string' && Array.isArray(v.widget_components);
}

function safeReadJson(_x) {
  return _safeReadJson.apply(this, arguments);
}

function _safeReadJson() {
  _safeReadJson = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
    var text;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return response.text();

          case 2:
            text = _context.sent;

            if (text) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            _context.prev = 5;
            return _context.abrupt("return", JSON.parse(text));

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", text);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 9]]);
  }));
  return _safeReadJson.apply(this, arguments);
}

function timedFetch(_x2, _x3) {
  return _timedFetch.apply(this, arguments);
}

function _timedFetch() {
  _timedFetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(url, init) {
    var startedAt, response, responseTimeMs, contentType, body, parsed;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            startedAt = Date.now();
            _context2.next = 3;
            return fetch(url, init);

          case 3:
            response = _context2.sent;
            responseTimeMs = Date.now() - startedAt;
            contentType = response.headers.get('Content-Type');

            if (response.ok) {
              _context2.next = 18;
              break;
            }

            body = '';
            _context2.prev = 8;
            _context2.next = 11;
            return response.text();

          case 11:
            body = _context2.sent;
            _context2.next = 16;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](8);

          case 16:
            if (body) {
              console.warn('[Forethought] upstream error body:', body.slice(0, 1000));
            }

            throw new ForethoughtApiError(extractErrorMessage(response.status, body, contentType), response.status);

          case 18:
            _context2.next = 20;
            return safeReadJson(response);

          case 20:
            parsed = _context2.sent;

            if (isConversationResponse(parsed)) {
              _context2.next = 24;
              break;
            }

            console.warn('[Forethought] unexpected response shape:', parsed);
            throw new ForethoughtApiError('The AI assistant returned an unexpected response. Please try again.');

          case 24:
            return _context2.abrupt("return", {
              data: parsed,
              responseTimeMs: responseTimeMs
            });

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 14]]);
  }));
  return _timedFetch.apply(this, arguments);
}

function startConversation(_x4, _x5) {
  return _startConversation.apply(this, arguments);
}

function _startConversation() {
  _startConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(query, signal) {
    var body;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            body = {
              stream: false,
              query: query,
              context_variables: {}
            };
            return _context3.abrupt("return", timedFetch((0, _absoluteUrlRuntime.resolveUrl)(PROXY_START, _absoluteUrlRuntime.UrlSourceType.Api), {
              method: 'POST',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _startConversation.apply(this, arguments);
}

function continueConversation(_x6, _x7) {
  return _continueConversation.apply(this, arguments);
}

function _continueConversation() {
  _continueConversation = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(conversationId, query) {
    var contextVariables,
        signal,
        body,
        url,
        _args4 = arguments;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            contextVariables = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            signal = _args4.length > 3 ? _args4[3] : undefined;
            body = {
              stream: false,
              query: query,
              context_variables: contextVariables
            };
            url = "".concat((0, _absoluteUrlRuntime.resolveUrl)(PROXY_CONTINUE, _absoluteUrlRuntime.UrlSourceType.Api), "?id=").concat(encodeURIComponent(conversationId));
            return _context4.abrupt("return", timedFetch(url, {
              method: 'PUT',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            }));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _continueConversation.apply(this, arguments);
}

function submitCsat(_x8, _x9, _x10, _x11) {
  return _submitCsat.apply(this, arguments);
}

function _submitCsat() {
  _submitCsat = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(conversationId, rating, feedback, signal) {
    var body, url, response;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            body = {
              rating: rating
            };
            if (feedback) body.feedback = feedback;
            url = "".concat((0, _absoluteUrlRuntime.resolveUrl)(PROXY_CSAT, _absoluteUrlRuntime.UrlSourceType.Api), "?id=").concat(encodeURIComponent(conversationId));
            _context5.next = 5;
            return fetch(url, {
              method: 'POST',
              headers: buildHeaders(),
              body: JSON.stringify(body),
              signal: signal
            });

          case 5:
            response = _context5.sent;

            if (response.ok) {
              _context5.next = 8;
              break;
            }

            throw new Error("CSAT submission failed: ".concat(response.status));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _submitCsat.apply(this, arguments);
}